import UserImageActions from './userImageActions';
import UserLocalisation from './userLocalisation';
import { Box, Grid } from '@mui/material';
import '../../../css/users/userDetailsContent.css';

const UserDetailsContent = () => {
  return (
    <Grid container spacing={3} className='userDetailsContent_main_grid'>
      <Grid item xs={12} md={4} padding={3}>
        <Box className='userDetailsContent_image_chiffre_box'>
          <UserImageActions />
        </Box>
      </Grid>
      <Grid item xs={12} md={8} padding={3}>
        <Box className='userDetailsContent_second_grid_box'>
          <UserLocalisation />
        </Box>
      </Grid>
    </Grid>
  );
}

export default UserDetailsContent;